// CUSTOM: bocket-contact-type-filter — BKT-027 / bocket-conversations-contact-type — BKT-028
// Reglas puras del filtro "Tipo de contacto" (sin estado ni API), usadas
// por el menu, la lista de contactos, la de conversaciones y el store.

// Valor de ruta para los contactos sin tipo asignado.
export const CONTACT_TYPE_NONE = '__none__';

export const isContactTypeFilterEnabled = () =>
  window.bocketConfig?.contactTypeFilterEnabled !== false;

// Los valores se guardan como claves ("familiar_amigo"); en el menu y el
// titulo se muestran legibles ("Familiar amigo"). El filtro usa el valor crudo.
export const formatContactTypeLabel = value => {
  const text = String(value ?? '')
    .replace(/_/g, ' ')
    .trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

// CUSTOM: bocket-contact-type-sort-by-count — BKT-029
// Orden del menu: mas contactos/conversaciones primero. Si empatan, se
// mantiene el orden configurado en la lista del atributo (sort estable).
export const sortContactTypeValuesByCount = (values = []) =>
  [...values].sort((a, b) => (b.count || 0) - (a.count || 0));

// Filtro para POST /contacts/filter. Coincide con como cuenta el backend
// (LOWER(custom_attributes ->> key)), asi el numero del menu y la lista cuadran.
export const buildContactTypeFilterPayload = (
  attributeKey,
  attributeValue
) => ({
  payload: [
    attributeValue === CONTACT_TYPE_NONE
      ? {
          attribute_key: attributeKey,
          filter_operator: 'is_not_present',
          values: [],
        }
      : {
          attribute_key: attributeKey,
          filter_operator: 'equal_to',
          values: [attributeValue],
        },
  ],
});

// BKT-028: el mismo filtro existe para conversaciones (cuenta conversaciones).
export const CONTACT_TYPE_TARGETS = {
  CONTACTS: 'contacts',
  CONVERSATIONS: 'conversations',
};

export const isConversationsContactTypeEnabled = () =>
  isContactTypeFilterEnabled() &&
  window.bocketConfig?.conversationsContactTypeEnabled !== false;

// Rutas de la vista de conversaciones por tipo (BKT-028).
export const CONVERSATION_CONTACT_TYPE_ROUTES = [
  'contact_type_conversations',
  'conversations_through_contact_type',
];

// { key, value } si la ruta actual es una vista de conversaciones por tipo.
export const getConversationContactType = route => {
  if (!CONVERSATION_CONTACT_TYPE_ROUTES.includes(route?.name)) return {};
  return {
    key: route.params.contactTypeKey,
    value: route.params.contactTypeValue,
  };
};

// Filtro en el navegador (conversaciones que llegan en vivo). Misma regla
// que el servidor: comparacion sin mayusculas y "Sin tipo" = sin valor.
export const matchesContactType = (conversation, key, value) => {
  if (!key) return true;
  const raw = conversation?.meta?.sender?.custom_attributes?.[key];
  const hasValue = raw !== undefined && raw !== null;
  if (value === CONTACT_TYPE_NONE) return !hasValue;
  return hasValue && String(raw).toLowerCase() === String(value).toLowerCase();
};
